
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    className: {
      required: false,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    detail: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    modelValue: {
      required: false,
      type: [String, Number],
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
    maxlength: {
      required: false,
      type: [Number, String],
    },
    oninput: {
      required: false,
      type: String,
    },
    inputmode: {
      required: false,
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    // const input = ref(props.value);
    return {};
  },
  methods: {},
});
